module.exports = __webpack_public_path__ + "img/bg40.892295bb.png";